import {
    setTimeout
} from "timers";
import {
    Settings
} from "luxon";
import Axios from 'axios';
import _ from 'lodash';
import ClipboardJS from 'clipboard';
import qr from 'qr-image';

const COUNTRY_LIST = [{
    code: "+86",
    name: "中国"
},
{
    code: "+93",
    name: "Afghanistan"
},
{
    code: "+355",
    name: "Albania"
},
{
    code: "+213",
    name: "Algeria"
},
{
    code: "+1684",
    name: "American Samoa"
},
{
    code: "+376",
    name: "Andorra"
},
{
    code: "+244",
    name: "Angola"
},
{
    code: "+1264",
    name: "Anguilla"
},
{
    code: "+1268",
    name: "Antigua and Barbuda"
},
{
    code: "+54",
    name: "Argentina"
},
{
    code: "+374",
    name: "Armenia"
},
{
    code: "+297",
    name: "Aruba"
},
{
    code: "+61",
    name: "Australia"
},
{
    code: "+43",
    name: "Austria"
},
{
    code: "+994",
    name: "Azerbaijan"
},
{
    code: "+1242",
    name: "Bahamas"
},
{
    code: "+973",
    name: "Bahrain"
},
{
    code: "+880",
    name: "Bangladesh"
},
{
    code: "+1246",
    name: "Barbados"
},
{
    code: "+375",
    name: "Belarus"
},
{
    code: "+32",
    name: "Belgium"
},
{
    code: "+501",
    name: "Belize"
},
{
    code: "+229",
    name: "Benin"
},
{
    code: "+1441",
    name: "Bermuda"
},
{
    code: "+975",
    name: "Bhutan"
},
{
    code: "+591",
    name: "Bolivia"
},
{
    code: "+387",
    name: "Bosnia and Herzegovina"
},
{
    code: "+267",
    name: "Botswana"
},
{
    code: "+55",
    name: "Brazil"
},
{
    code: "+673",
    name: "Brunei"
},
{
    code: "+359",
    name: "Bulgaria"
},
{
    code: "+226",
    name: "Burkina Faso"
},
{
    code: "+257",
    name: "Burundi"
},
{
    code: "+855",
    name: "Cambodia"
},
{
    code: "+237",
    name: "Cameroon"
},
{
    code: "+1",
    name: "Canada"
},
{
    code: "+238",
    name: "Cape Verde"
},
{
    code: "+1345",
    name: "Cayman Islands"
},
{
    code: "+236",
    name: "Central African Republic"
},
{
    code: "+235",
    name: "Chad"
},
{
    code: "+56",
    name: "Chile"
},
{
    code: "+57",
    name: "Colombia"
},
{
    code: "+269",
    name: "Comoros"
},
{
    code: "+682",
    name: "Cook Islands"
},
{
    code: "+506",
    name: "Costa Rica"
},
{
    code: "+385",
    name: "Croatia"
},
{
    code: "+53",
    name: "Cuba"
},
{
    code: "+599",
    name: "Curacao"
},
{
    code: "+357",
    name: "Cyprus"
},
{
    code: "+420",
    name: "Czech"
},
{
    code: "+243",
    name: "Democratic Republic of the Congo"
},
{
    code: "+45",
    name: "Denmark"
},
{
    code: "+253",
    name: "Djibouti"
},
{
    code: "+1767",
    name: "Dominica"
},
{
    code: "+1809",
    name: "Dominican Republic"
},
{
    code: "+593",
    name: "Ecuador"
},
{
    code: "+20",
    name: "Egypt"
},
{
    code: "+503",
    name: "El Salvador"
},
{
    code: "+240",
    name: "Equatorial Guinea"
},
{
    code: "+291",
    name: "Eritrea"
},
{
    code: "+372",
    name: "Estonia"
},
{
    code: "+251",
    name: "Ethiopia"
},
{
    code: "+298",
    name: "Faroe Islands"
},
{
    code: "+679",
    name: "Fiji"
},
{
    code: "+358",
    name: "Finland"
},
{
    code: "+33",
    name: "France"
},
{
    code: "+594",
    name: "French Guiana"
},
{
    code: "+689",
    name: "French Polynesia"
},
{
    code: "+241",
    name: "Gabon"
},
{
    code: "+220",
    name: "Gambia"
},
{
    code: "+995",
    name: "Georgia"
},
{
    code: "+49",
    name: "Germany"
},
{
    code: "+233",
    name: "Ghana"
},
{
    code: "+350",
    name: "Gibraltar"
},
{
    code: "+30",
    name: "Greece"
},
{
    code: "+299",
    name: "Greenland"
},
{
    code: "+1473",
    name: "Grenada"
},
{
    code: "+590",
    name: "Guadeloupe"
},
{
    code: "+1671",
    name: "Guam"
},
{
    code: "+502",
    name: "Guatemala"
},
{
    code: "+224",
    name: "Guinea"
},
{
    code: "+245",
    name: "Guinea-Bissau"
},
{
    code: "+592",
    name: "Guyana"
},
{
    code: "+509",
    name: "Haiti"
},
{
    code: "+504",
    name: "Honduras"
},
{
    code: "+852",
    name: "Hong Kong,China"
},
{
    code: "+36",
    name: "Hungary"
},
{
    code: "+354",
    name: "Iceland"
},
{
    code: "+91",
    name: "India"
},
{
    code: "+62",
    name: "Indonesia"
},
{
    code: "+98",
    name: "Iran"
},
{
    code: "+964",
    name: "Iraq"
},
{
    code: "+353",
    name: "Ireland"
},
{
    code: "+972",
    name: "Israel"
},
{
    code: "+39",
    name: "Italy"
},
{
    code: "+225",
    name: "Ivory Coast"
},
{
    code: "+1876",
    name: "Jamaica"
},
{
    code: "+81",
    name: "Japan"
},
{
    code: "+962",
    name: "Jordan"
},
{
    code: "+7",
    name: "Kazakhstan"
},
{
    code: "+254",
    name: "Kenya"
},
{
    code: "+686",
    name: "Kiribati"
},
{
    code: "+965",
    name: "Kuwait"
},
{
    code: "+996",
    name: "Kyrgyzstan"
},
{
    code: "+856",
    name: "Laos"
},
{
    code: "+371",
    name: "Latvia"
},
{
    code: "+961",
    name: "Lebanon"
},
{
    code: "+266",
    name: "Lesotho"
},
{
    code: "+231",
    name: "Liberia"
},
{
    code: "+218",
    name: "Libya"
},
{
    code: "+423",
    name: "Liechtenstein"
},
{
    code: "+370",
    name: "Lithuania"
},
{
    code: "+352",
    name: "Luxembourg"
},
{
    code: "+853",
    name: "Macau,China"
},
{
    code: "+389",
    name: "Macedonia"
},
{
    code: "+261",
    name: "Madagascar"
},
{
    code: "+265",
    name: "Malawi"
},
{
    code: "+60",
    name: "Malaysia"
},
{
    code: "+960",
    name: "Maldives"
},
{
    code: "+223",
    name: "Mali"
},
{
    code: "+356",
    name: "Malta"
},
{
    code: "+596",
    name: "Martinique"
},
{
    code: "+222",
    name: "Mauritania"
},
{
    code: "+230",
    name: "Mauritius"
},
{
    code: "+269",
    name: "Mayotte"
},
{
    code: "+52",
    name: "Mexico"
},
{
    code: "+373",
    name: "Moldova"
},
{
    code: "+377",
    name: "Monaco"
},
{
    code: "+976",
    name: "Mongolia"
},
{
    code: "+382",
    name: "Montenegro"
},
{
    code: "+1664",
    name: "Montserrat"
},
{
    code: "+212",
    name: "Morocco"
},
{
    code: "+258",
    name: "Mozambique"
},
{
    code: "+95",
    name: "Myanmar"
},
{
    code: "+264",
    name: "Namibia"
},
{
    code: "+977",
    name: "Nepal"
},
{
    code: "+31",
    name: "Netherlands"
},
{
    code: "+687",
    name: "New Caledonia"
},
{
    code: "+64",
    name: "New Zealand"
},
{
    code: "+505",
    name: "Nicaragua"
},
{
    code: "+227",
    name: "Niger"
},
{
    code: "+234",
    name: "Nigeria"
},
{
    code: "+47",
    name: "Norway"
},
{
    code: "+968",
    name: "Oman"
},
{
    code: "+92",
    name: "Pakistan"
},
{
    code: "+680",
    name: "Palau"
},
{
    code: "+970",
    name: "Palestine"
},
{
    code: "+507",
    name: "Panama"
},
{
    code: "+675",
    name: "Papua New Guinea"
},
{
    code: "+595",
    name: "Paraguay"
},
{
    code: "+51",
    name: "Peru"
},
{
    code: "+63",
    name: "Philippines"
},
{
    code: "+48",
    name: "Poland"
},
{
    code: "+351",
    name: "Portugal"
},
{
    code: "+1787",
    name: "Puerto Rico"
},
{
    code: "+974",
    name: "Qatar"
},
{
    code: "+242",
    name: "Republic Of The Congo"
},
{
    code: "+262",
    name: "Réunion Island"
},
{
    code: "+40",
    name: "Romania"
},
{
    code: "+7",
    name: "Russia"
},
{
    code: "+250",
    name: "Rwanda"
},
{
    code: "+1869",
    name: "Saint Kitts and Nevis"
},
{
    code: "+1758",
    name: "Saint Lucia"
},
{
    code: "+508",
    name: "Saint Pierre and Miquelon"
},
{
    code: "+1784",
    name: "Saint Vincent and The Grenadines"
},
{
    code: "+685",
    name: "Samoa"
},
{
    code: "+378",
    name: "San Marino"
},
{
    code: "+239",
    name: "Sao Tome and Principe"
},
{
    code: "+966",
    name: "Saudi Arabia"
},
{
    code: "+221",
    name: "Senegal"
},
{
    code: "+381",
    name: "Serbia"
},
{
    code: "+248",
    name: "Seychelles"
},
{
    code: "+232",
    name: "Sierra Leone"
},
{
    code: "+65",
    name: "Singapore"
},
{
    code: "+1721",
    name: "Saint Maarten (Dutch Part)"
},
{
    code: "+421",
    name: "Slovakia"
},
{
    code: "+386",
    name: "Slovenia"
},
{
    code: "+677",
    name: "Solomon Islands"
},
{
    code: "+252",
    name: "Somalia"
},
{
    code: "+27",
    name: "South Africa"
},
{
    code: "+82",
    name: "South Korea"
},
{
    code: "+34",
    name: "Spain"
},
{
    code: "+94",
    name: "Sri Lanka"
},
{
    code: "+249",
    name: "Sudan"
},
{
    code: "+597",
    name: "Suriname"
},
{
    code: "+268",
    name: "Swaziland"
},
{
    code: "+46",
    name: "Sweden"
},
{
    code: "+41",
    name: "Switzerland"
},
{
    code: "+963",
    name: "Syria"
},
{
    code: "+886",
    name: "Taiwan,China"
},
{
    code: "+992",
    name: "Tajikistan"
},
{
    code: "+255",
    name: "Tanzania"
},
{
    code: "+66",
    name: "Thailand"
},
{
    code: "+670",
    name: "Timor-Leste"
},
{
    code: "+228",
    name: "Togo"
},
{
    code: "+676",
    name: "Tonga"
},
{
    code: "+1868",
    name: "Trinidad and Tobago"
},
{
    code: "+216",
    name: "Tunisia"
},
{
    code: "+90",
    name: "Turkey"
},
{
    code: "+993",
    name: "Turkmenistan"
},
{
    code: "+1649",
    name: "Turks and Caicos Islands"
},
{
    code: "+256",
    name: "Uganda"
},
{
    code: "+380",
    name: "Ukraine"
},
{
    code: "+971",
    name: "United Arab Emirates"
},
{
    code: "+44",
    name: "United Kingdom"
},
{
    code: "+1",
    name: "United States"
},
{
    code: "+598",
    name: "Uruguay"
},
{
    code: "+998",
    name: "Uzbekistan"
},
{
    code: "+678",
    name: "Vanuatu"
},
{
    code: "+58",
    name: "Venezuela"
},
{
    code: "+84",
    name: "Vietnam"
},
{
    code: "+1340",
    name: "Virgin Islands, British"
},
{
    code: "+1284",
    name: "Virgin Islands, US"
},
{
    code: "+967",
    name: "Yemen"
},
{
    code: "+260",
    name: "Zambia"
},
{
    code: "+263",
    name: "Zimbabwe"
}
];

// todo
// paypal clentid 
// testnet
// const PAYPAL_CLENT_ID = 'AVy8th_PQ4OAAXznCBFPk7zXgXiMVV09uwoGoird-c9NUD7pm9CZPPxGA7ZHrHTFv3VwcWNqOZpxhJWt';
// online
const PAYPAL_CLENT_ID = 'AQ-cIDmq-blzn7R7jIfw8H877kKq6XRgUtx5I5nWCz4moJAo7pigyiae6HNWjzuNgCom-7PeXhCihsBQ';

// const DOMAIN = 'https://preserver.mytokenpocket.vip';
const DOMAIN = 'https://preserver.mytokenpocket.vip';



// alipay
const appid = 2018100961582938;

const dynamicLoadJs = function (url, callback) {
    let head = document.getElementsByTagName("head")[0];
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = url;
    if (typeof callback == "function") {
        script.onload = script.onreadystatechange = function () {
            if (
                !this.readyState ||
                this.readyState === "loaded" ||
                this.readyState === "complete"
            ) {
                callback();
                script.onload = script.onreadystatechange = null;
            }
        };
    }
    head.appendChild(script);
};

const BLOCKCHAIN_ID_MAP = {
    'eos': 4,
    'enu': 5,
    'bos': 6,
    'iost': 7
}

export default {
    name: "HelloWorld",
    data() {
        return {
            currentBc: "eos",
            currPayment: "alipay",
            price: "￥7.90",
            currentMethod: "phone",
            countryList: COUNTRY_LIST,
            isPaypalInit: false,
            eosCnPrice: '',
            bosCnPrice: '',
            iostCnPrice: '',
            eosUsPrice: '',
            bosUsPrice: '',
            iostUsPrice: '',
            currPrice: '',
            mailInput: '',
            phoneInput: '',
            msg: '',
            currentArea: '+86',
            hasRefer: false,
            refer: '',
            refBlockchainId: '',
            isResult: false,
            outTradeNo: '',
            code: '',
            codeType: '',
            isSupportCopy: true,
            isMobile: true,
            isWechat: false,
            isPc: false,
            qrImgUrl: '',
            wechatCode: '',
            weixinTimer: null,
            isPaypalAvaileble: false
        };
    },
    created() {
        if (navigator.userAgent.toLowerCase().match(/(ipod|iphone|android|coolpad|tokenpocket|mmp|smartphone|midp|wap|xoom|j2me|blackberry)/i) != null) {
            this.isMobile = true;
            this.isPc = false;
        } else {
            this.isMobile = false;
            this.isPc = true;
        }

        // 英文环境默认 paypal

        if (this.$i18n.locale === 'en' && this.isPaypalAvaileble) {
            this.currPayment = 'paypal';
            this.currentMethod = 'email';
        }

        let _this = this;

        function onBridgeReady() {
            _this.isWechat = true;
            _this.currPayment = 'weixin';

            // 回调了
            if (location.href.indexOf('code=') > -1) {
                const query = location.search.substr(1);
                const queryObj = {};

                if (query) {
                    _.each(query.split('&'), item => {
                        const tempArr = item.split('=');
                        queryObj[tempArr[0]] = tempArr[1];
                    });
                }

                _this.wechatCode = queryObj['code'];

            } else {
                let url = location.protocol + '//' + location.hostname + '/' + location.search;
                location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd0b7403e0e727a0&redirect_uri=" + encodeURIComponent(url) + "&response_type=code&scope=snsapi_base"
            }
        }
        if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
            } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
            }
        } else {
            onBridgeReady();
        }

        if (typeof WeixinJSBridge == "undefined") {
            this.isWechat = false;
        } else {
            this.isWechat = true;
        }


        if (this.$route.params.blockchain) {
            this.currentBc = this.$route.params.blockchain;
        }

        this.checkParams();

        this.getEosCnPrice();
        this.getBosCnPrice();
        this.getIostCnPrice();
        this.getEosUsPrice();
        this.getBosUsPrice();
        this.getIostUsPrice();
    },
    mounted() {
        if (this.currPayment === "paypal" && this.isPaypalAvaileble) {
            this.initPaypal();
        }
    },
    methods: {
        changeLang(lang) {
            this.$i18n.locale = lang;
            localStorage.setItem("locale", lang);
            if (lang === "en") {
                Settings.defaultLocale = "en-US";
            } else {
                Settings.defaultLocale = "zh-CN";
            }
        },
        goBuyAgain() {
            window.location = '/#/' + this.codeType;
        },
        checkParams() {
            let query = location.search.substr(1);
            let queryObj = {}

            if (query) {
                let queryArr = query.split('&');
                for (let i = 0; i < queryArr.length; i++) {
                    queryObj[queryArr[i].split('=')[0]] = queryArr[i].split('=')[1];
                }

                // 是否有refer
                if (queryObj['refer']) {
                    this.hasRefer = true;
                    this.refer = queryObj['refer'];
                }

                // refer 底层
                if (queryObj['ref_blockchain_id']) {
                    this.refBlockchainId = queryObj['ref_blockchain_id'];
                }


                if (queryObj['payment'] === 'weixin') {
                    this.currPayment = queryObj['payment'];
                    this.currentBc = queryObj['type'];
                    this.codeType = queryObj['type'];
                    this.outTradeNo = queryObj['out_trade_no'];

                    this.autoCheckTradeNo(this.outTradeNo);

                    // setTimeout(() => {
                    //     this.getCode();
                    // }, 100)

                    // setTimeout(()=> {
                    //     this.getCode();
                    // }, 2000)
                } else if (queryObj['type'] && queryObj['out_trade_no']) {
                    this.isResult = true;

                    this.currentBc = queryObj['type'];
                    this.codeType = queryObj['type'];
                    this.outTradeNo = queryObj['out_trade_no'];

                    this.getCode();

                }
            }
        },
        getCode() {
            this.showCommonCode();
        },
        // eos bos
        showCommonCode() {
            Axios.get(DOMAIN + '/v1/invite_code/getcode?out_trade_no=' + this.outTradeNo).then(res => {
                if (res.status === 200 && res.data.result === 0) {

                    if (this.currPayment === 'weixin' && res.data.data.status !== 2 && res.data.data.status !== 3) {
                        // this.code = this.$t('i18nView.noPay');
                    } else {
                        this.isResult = true;
                        this.code = res.data.data.code;
                        this.initCodeCopy();
                    }

                }
            })
        },
        initCodeCopy() {
            var _this = this;
            if (ClipboardJS.isSupported()) {
                let clipboard = new ClipboardJS('.copy-btn', {
                    text: function () {
                        return _this.code;
                    }
                });

                clipboard.on('success', (e) => {
                    _this.msg = '复制成功';
                    _this.$modal.show("message");
                });

                clipboard.on('error', (e) => {
                    _this.msg = '复制失败，请手动复制';
                    _this.$modal.show("message");
                });
            } else {
                this.isSupportCopy = false;
            }
        },
        getEosCnPrice() {
            return Axios.get(DOMAIN + '/v1/invite_code/account_fee?blockchain_id=4').then(res => {
                if (res.status === 200 && res.data.result === 0) {
                    this.eosCnPrice = res.data.data;
                    this.checkPrice();
                    return res.data.data;
                }
            });
        },
        getBosCnPrice() {
            return Axios.get(DOMAIN + '/v1/invite_code/account_fee?blockchain_id=6').then(res => {
                if (res.status === 200 && res.data.result === 0) {
                    this.bosCnPrice = res.data.data;
                    this.checkPrice();
                    return res.data.data;
                }
            });
        },
        getIostCnPrice() {
            return Axios.get(DOMAIN + '/v1/invite_code/account_fee?blockchain_id=7').then(res => {
                if (res.status === 200 && res.data.result === 0) {
                    this.iostCnPrice = res.data.data;
                    this.checkPrice();
                    return res.data.data;
                }
            });
        },
        getEosUsPrice() {
            return Axios.get(DOMAIN + '/v1/invite_code/account_fee?blockchain_id=4&pay_type=2').then(res => {
                if (res.status === 200 && res.data.result === 0) {
                    this.eosUsPrice = res.data.data;
                    this.checkPrice();
                    return res.data.data;
                }
            });
        },
        getBosUsPrice() {
            return Axios.get(DOMAIN + '/v1/invite_code/account_fee?blockchain_id=6&pay_type=2').then(res => {
                if (res.status === 200 && res.data.result === 0) {
                    this.bosUsPrice = res.data.data;
                    this.checkPrice();
                    return res.data.data;
                }
            });
        },
        getIostUsPrice() {
            return Axios.get(DOMAIN + '/v1/invite_code/account_fee?blockchain_id=7&pay_type=2').then(res => {
                if (res.status === 200 && res.data.result === 0) {
                    this.iostUsPrice = res.data.data;
                    this.checkPrice();
                    return res.data.data;
                }
            });
        },
        confirm(fixedPrice) {
            // 底层
            let blockchain_id = BLOCKCHAIN_ID_MAP[this.currentBc];
            // 付款方式
            let payment = this.currPayment;
            // 接收激活码的方式
            let receivedMethod = this.currentMethod;

            let price;

            if (blockchain_id === 4) {
                price = this.eosCnPrice;
            } else if (blockchain_id === 6) {
                price = this.bosCnPrice;
            } else if (blockchain_id === 7) {
                price = this.iostCnPrice;
            }

            price = '' + price;

            if (fixedPrice) {
                price = parseFloat(fixedPrice).toFixed(2);
            }

            // 确认有价格信息
            if (!price) {
                this.msg = '获取价格失败，请刷新页面';
                this.$modal.show("message");
            }

            this[payment](price, blockchain_id, receivedMethod);




        },
        // 切换金额展示
        checkPrice() {
            if (this.currPayment === 'paypal' && this.isPaypalAvaileble) {
                switch (this.currentBc) {
                    case 'eos':
                        this.currPrice = '$' + this.eosUsPrice;
                        break;
                    case 'bos':
                        this.currPrice = '$' + this.bosUsPrice;
                        break;
                    case 'iost':
                        this.currPrice = '$' + this.iostUsPrice;
                        break;
                    default:
                        break;
                }
            } else {
                switch (this.currentBc) {
                    case 'eos':
                        this.currPrice = '￥' + this.eosCnPrice;
                        break;
                    case 'bos':
                        this.currPrice = '￥' + this.bosCnPrice;
                        break;
                    case 'iost':
                        this.currPrice = '￥' + this.iostCnPrice;
                        break;
                    default:
                        break;
                }
            }
        },
        changeBc(bc) {
            if (!this.isResult) {
                this.currentBc = bc;
                this.checkPrice();
            }

            if (this.currPayment === 'paypal' && this.isPaypalAvaileble) {
                this.initPaypal();
            }

        },
        changePayment(pay) {
            if (this.currPayment !== pay && pay === "paypal" && this.isPaypalAvaileble) {
                setTimeout(this.initPaypal, 10);
            }
            this.currPayment = pay;
            this.checkPrice();
        },
        changeMethod(method) {
            this.currentMethod = method;
        },
        initPaypal() {
            if (!this.isPaypalAvaileble) {
                return;
            }
            if (this.isPaypalInit) {
                this.initPaypalBtn();
                return;
            }
            this.isPaypalInit = true;

            dynamicLoadJs(
                "https://www.paypal.com/sdk/js?client-id=" + PAYPAL_CLENT_ID,
                () => this.initPaypalBtn()
            );
        },
        realInitPaypalBtn(price) {
            if (document.getElementById('paypal-button-container')) {
                document.getElementById('paypal-button-container').innerHTML = '';
            }

            let receivedCode = '';
            let queryTimer = '';

            let _this = this;

            let blockchain_id = BLOCKCHAIN_ID_MAP[this.currentBc];

            let getCodeByOrder = function (orderId) {
                Axios.get(DOMAIN + '/v1/invite_code/getcode?out_trade_no=' + orderId, function (res) {
                    if (res.status === 200 && res.data.result === 0 && res.data.data && res.data.data.code) {
                        showTheCode(res.data.data.code);
                    }
                });
            }


            let showTheCode = function (code) {
                clearInterval(queryTimer);
                // 已经有了code
                if (receivedCode) {
                    return;
                }
                receivedCode = code;
                _this.code = code;
                _this.isResult = true;
                _this.codeType = _this.currentBc;

                if (ClipboardJS.isSupported()) {

                    let clipboard = new ClipboardJS('.copy-btn', {
                        text: function () {
                            return receivedCode;
                        }
                    });

                    clipboard.on('success', (e) => {
                        _this.msg = '复制成功';
                        _this.$modal.show("message");
                    });

                    clipboard.on('error', (e) => {
                        _this.msg = '复制失败，请手动复制';
                        _this.$modal.show("message");
                    });
                } else {
                    _this.isSupportCopy = false;
                }
            }

            paypal
                .Buttons({
                    createOrder: function (data, actions) {
                        receivedCode = null;
                        queryTimer = null;
                        return actions.order.create({
                            purchase_units: [{
                                amount: {
                                    value: price
                                }
                            }]
                        });
                    },
                    onApprove: function (data, actions) {
                        return actions.order.capture().then(function (details) {
                            // let params = {
                            //     order_id: data.orderID,
                            //     blockchain_id: blockchain_id,
                            //     refer: _this.refer,
                            //     ref_blockchain_id: _this.refBlockchainId
                            // };

                            let paypalParams = `order_id=${data.orderID}&blockchain_id=${blockchain_id}&refer=${_this.refer}&ref_blockchain_id=${_this.refBlockchainId}`;


                            let type = _this.currentMethod;

                            if (type === "email" && _.trim(_this.mailInput)) {
                                let email = _.trim(_this.mailInput);
                                paypalParams += `&email=${email}`;
                            } else if (type === "phone" && _.trim(_this.phoneInput)) {
                                let phone = _this.currentArea + '-' + _.trim(_this.phoneInput);
                                paypalParams += `&phone=${phone}`;
                            }

                            queryTimer = setInterval(function () {
                                getCodeByOrder(data.orderID);
                            }, 5000);


                            Axios({
                                method: 'post',
                                url: DOMAIN + "/v1/invite_code/paypal_checkout",
                                data: paypalParams
                            }).then(function (res) {
                                if (res.status === 200 && res.data.result === 0) {
                                    showTheCode(res.data.data);
                                } else {
                                    alert(res.message);
                                }
                            })
                        });
                    }
                })
                .render("#paypal-button-container");
        },
        initPaypalBtn() {
            if (!this.isPaypalAvaileble) {
                return;
            }

            let blockchain = this.currentBc;
            let price = this[this.currentBc + 'UsPrice'];
            if (price) {
                this.realInitPaypalBtn(price);
            } else {
                switch (blockchain) {
                    case 'eos':
                        this.getEosUsPrice().then(res => {
                            this.realInitPaypalBtn(res);
                        })
                        break;
                    case 'bos':
                        this.getBosUsPrice().then(res => {
                            this.realInitPaypalBtn(res);
                        })
                        break;
                    case 'iost':
                        this.getIostUsPrice().then(res => {
                            this.realInitPaypalBtn(res);
                        })
                }
            }



        },
        handleError(err) {
            let errorMsg = err;

            if (typeof err === "string") {
                try {
                    let errJson = JSON.parse(err);
                    if (errJson.error && errJson.error.details.length) {
                        errorMsg = errJson.error.details[0].message;
                    } else if (errJson.error) {
                        errorMsg = errJson.error.what;
                    } else {
                        errorMsg = errJson.message || errJson.code || errJson.msg;
                    }
                } catch (e) {
                    errorMsg = e;
                }
            } else {
                errorMsg = err.message || err.type || err.code;
            }
            this.msg = errorMsg;
            this.$modal.show("message");
        },

        alipay(price, blockchain_id, receivedMethod) {
            let phone = receivedMethod === 'phone' ? _.trim(this.phoneInput) : '';
            let mail = receivedMethod === 'email' ? _.trim(this.mailInput) : '';

            phone = !!phone ? (this.currentArea + '-' + phone) : '';

            let timestamp = '';
            let trade_no = (new Date).getTime();
            let is_mobi = navigator.userAgent.toLowerCase().match(
                /(ipod|iphone|android|coolpad|tokenpocket|mmp|smartphone|midp|wap|xoom|j2me|blackberry)/i) != null;

            let method = 'alipay.trade.page.pay';
            let product_code = 'FAST_INSTANT_TRADE_PAY';

            if (is_mobi) {
                method = 'alipay.trade.wap.pay';
                product_code = 'QUICK_WAP_PAY';
            }

            let notify_url = DOMAIN + '/v1/invite_code/AliPayNodify';

            let currentDomain = location.protocol + '//' + location.host;

            let return_url = currentDomain + '/?type=' + this.currentBc;
            // let return_url = currentDomain + '/result/' + trade_no;

            let params = 'app_id=' + appid +
                '&method=' + method +
                '&blockchain_id=' + blockchain_id +
                '&notify_url=' + notify_url +
                (this.hasRefer ? ('&refer=' + this.refer) : '') +
                (this.hasRefer ? ('&ref_blockchain_id=' + this.refBlockchainId) : '') +
                '&return_url=' + return_url +
                '&timestamp=' + timestamp +
                '&phone=' + phone +
                '&email=' + mail +
                '&sign_type=RSA2&version=1.0&charset=utf-8' +
                '&biz_content={"subject":"账号激活码","out_trade_no":"' +
                trade_no + '","timeout_express":"90m","total_amount":"' + price +
                '","product_code":"' + product_code + '"}';


            Axios.get(DOMAIN + '/v1/invite_code/AliPaySign?' +
                encodeURI(params)).then(res => {
                    if (res.status === 200 && res.data.result === 0) {
                        let newParams = 'app_id=' + appid +
                            '&method=' + method +
                            '&notify_url=' + notify_url +
                            '&return_url=' + return_url +
                            '&timestamp=' + res.data.timestamp +
                            '&sign_type=RSA2&version=1.0&charset=utf-8' +
                            '&biz_content={"subject":"账号激活码","out_trade_no":"' +
                            res.data.out_trade_no + '","timeout_express":"90m","total_amount":"' +
                            price +
                            '","product_code":"' + product_code + '"}';
                        window.location = 'https://openapi.alipay.com/gateway.do?' + newParams +
                            '&sign=' + res.data.sign;
                    }
                })

        },
        weixin(price, blockchain_id, receivedMethod) {

            var _this = this;

            let payType = '';
            if (this.isWechat) {
                payType = 'JSAPI';
            } else if (this.isMobile) {
                payType = 'MWEB';
            } else if (this.isPc) {
                payType = 'NATIVE'
            }

            let phone = receivedMethod === 'phone' ? _.trim(this.phoneInput) : '';
            let eamil = receivedMethod === 'email' ? _.trim(this.mailInput) : '';

            phone = phone ? (this.currentArea + '-' + phone) : '';

            let methodStr = '';
            if (phone) {
                methodStr = 'phone=' + phone;
            } else {
                methodStr = 'email=' + eamil;
            }
            let refBlockchainId = this.refBlockchainId;
            let refer = this.refer;

            let paramStr = `notify_url=${DOMAIN}/v1/invite_code/weixin_pay_nodify&total_fee=${parseFloat(100 * price).toFixed(0)}&blockchain_id=${blockchain_id}&ref_blockchain_id=${refBlockchainId}&pay_type=${payType}&refer=${refer}&${methodStr}`;

            // 微信内部需要添加 code
            if (payType === 'JSAPI') {
                paramStr += '&code=' + this.wechatCode;
            }

            Axios({
                method: 'post',
                url: DOMAIN + '/v1/invite_code/weixin_pay_order',
                data: paramStr

            }).then(res => {
                if (res.status === 200 && res.data.result === 0) {

                    let out_trade_no = res.data.data.out_trade_no;

                    switch (payType) {
                        case 'JSAPI':
                            // 微信内
                            if (WeixinJSBridge) {

                                var weixinParams = _.assignIn({}, res.data.data);

                                delete weixinParams.out_trade_no;

                                WeixinJSBridge.invoke(
                                    'getBrandWCPayRequest', weixinParams,
                                    function (res) {
                                        if (res.err_msg == "get_brand_wcpay_request:ok") {
                                            _this.autoCheckTradeNo(out_trade_no);
                                        }
                                        if (res.err_msg == 'get_brand_wcpay_request:cancel') {
                                            alert('用户已取消');
                                            return;
                                        }
                                        if (res.err_msg == 'get_brand_wcpay_request:fail') {
                                            alert('支付失败');
                                            return;
                                        }
                                    });
                            }
                            break;
                        case 'NATIVE':
                            // PC扫码
                            let wxUrl = res.data.data.code_url;

                            var base64Str = qr.imageSync(wxUrl, {
                                size: 5,
                                type: 'png'
                            })

                            this.qrImgUrl = 'data:image/png;base64,' + base64Str.toString('base64');
                            this.$modal.show('qr');

                            this.autoCheckTradeNo(out_trade_no);

                            break;
                        default:
                            // 移动浏览器
                            window.location = res.data.data.mweb_url + '&redirect_url=' + encodeURIComponent(location.protocol + '//' + location.host + '/?type=' + this.currentBc + '&out_trade_no=' + out_trade_no + '&payment=weixin');
                            break;
                    }

                }
            }).catch(err => {
                this.handleError(err);
            })
        },
        // mainly weixin
        autoCheckTradeNo(tradeNo) {

            if (this.weixinTimer) {
                clearInterval(this.weixinTimer);
            }

            this.weixinTimer = setInterval(() => {
                Axios.get(DOMAIN + '/v1/invite_code/getcode?out_trade_no=' + tradeNo).then(res => {
                    if (res.status === 200 && res.data.result === 0 && res.data.data && res.data.data.code && (res.data.data.status === 2 || res.data.data.status === 3)) {
                        // 激活码已支付
                        clearInterval(this.weixinTimer);

                        let currentDomain = location.protocol + '//' + location.host;

                        location.href = currentDomain + '/?type=' + this.currentBc + '&out_trade_no=' + tradeNo;

                    }
                })

            }, 2000);


        }
    }
};